import React from 'react'
import { Message, MessageBody, MessageHeader, Button } from '../bulma'

/**
* Empty state for product grid. Displays a message indicating there are no
* results to be displays and they shouldn't expect them.
*/
function ProductGridEmpty(props) {
  // Determine url for "Clear Filters" button.
  const url = new Url()

  url.clearQuery()

  return (
    <Message>
      <MessageHeader>
        No products could be found.
      </MessageHeader>
      <MessageBody>
        <div>
          Sorry, we couldn't find any product based on your request.
        </div>
        <div>
          Try:
          <ul>
            <li>Clearing any filters.</li>
            <li>Checking your spelling.</li>
            <li>Using more general terms.</li>
          </ul>
        </div>
        <div>
          <Button
            href={String(url)}
            trackEvent
            eventCategory="Search"
            eventAction="Clear Filters"
            eventLabel="No Products Message"
          >
            Clear Filters
          </Button>
        </div>
      </MessageBody>
    </Message>
  )
}

export default ProductGridEmpty
